/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: dashboard
 *| (C) Copyright IBM Corp. 2016, 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([], function() {

	return {
		isStoryMode: function(glassContext) {

			if (glassContext.appController.currentAppView.currentContentView) {
				return glassContext.appController.currentAppView.currentContentView.isStoryMode === true;
			}
			return glassContext.appController.currentAppView.defaultContent.isStoryMode === true;

		},

		/** Returns true if we're in 'development' mode, false otherwise. */
		isDevMode: function(services) {
			if (services && services.biGlass && services.biGlass.glassContext && services.biGlass.glassContext.isDevInstall) {
				return services.biGlass.glassContext.isDevInstall();
			}
			return false;
		},

		getAjaxService: function(glassContext) {
			return glassContext.services.ajax;
		}
	};
});
